module.exports = __webpack_public_path__ + "img/Memoriam.456e83ff.png";